import Quill from 'quill';

const embedBlotName = 'addButton';
const BlockEmbedHtml = Quill.import('blots/block/embed');

class EmbedHtmlBlot extends BlockEmbedHtml {
  static create(value) {
    const parentNode = super.create();
    parentNode.setAttribute('id', `blot-custom-id---${value.shortId}`);
    parentNode.setAttribute('class', value.class);
    parentNode.setAttribute('toggleon',value.backgroundColor=='rgba(253, 100, 129, 1)'?true:false);
    parentNode.setAttribute('style', `background: ${value.backgroundColor} !important; color: ${value.textColor} !important`);

    let childNode = document.createElement('a');
    childNode.innerText = value.text;
    childNode.setAttribute('href', value.link);
    childNode.setAttribute('target', value.target);

    parentNode.appendChild(childNode);
    return parentNode;
  }

  static value(node) {
    return {
      class: node.getAttribute('class'),
      backgroundColor: node.style.background,
      textColor: node.style.color,
      shortId: node.id.split('---').at(-1),
      link: node.childNodes[0].getAttribute('href'),
      text: node.childNodes[0].innerText,
      target: node.childNodes[0].getAttribute('target'),
      toggleon: node.backgroundColor=='rgba(253, 100, 129, 1)'?true:false,
    };
  }
}

EmbedHtmlBlot.blotName = embedBlotName;
EmbedHtmlBlot.tagName = 'b';
Quill.register(EmbedHtmlBlot);
